import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  inMemoryPersistence,
} from "firebase/auth";
import firebaseConfig from "../config/firebaseConfig";
import { useLocalStorageAuthPersistence } from "./authPersistence";
import { createFirestoreWithPersistence } from "./initFirestore";

const app = initializeApp(firebaseConfig);

/**
 * Auth without the Google redirect iframe.
 * `getAuth` installs `browserPopupRedirectResolver`, and on iPhone, iPad, and
 * Android that resolver is awaited during startup. If the iframe never
 * answers, `onAuthStateChanged` never fires and the page stays on the boot
 * spinner. Popup sign-in passes the resolver only when the user taps Google.
 * @param {import('firebase/app').FirebaseApp} firebaseApp
 */
function createAuth(firebaseApp) {
  const persistence = useLocalStorageAuthPersistence()
    ? [browserLocalPersistence, browserSessionPersistence, inMemoryPersistence]
    : [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence];
  try {
    return initializeAuth(firebaseApp, { persistence });
  } catch {
    // Hot reload: Auth was already created for this app.
    return getAuth(firebaseApp);
  }
}

export const auth = createAuth(app);
export const db = createFirestoreWithPersistence(app);
export default app;

